/**
 * Media CATALOG bridge (F2-B → F2-D `gen:features`).
 *
 * Emits `FeatureManifest`s (same shape as `countryPackManifests()`) for the
 * media features that live in TS registries: the `video` block. The meeting
 * providers expose their own `mediaProviderManifests()` in `../live`.
 */

import type { FeatureManifest } from "../academy/country/packs";
import { videoBlock } from "../learning-blocks/blocks/video";

/** Catalog key for the video block. */
export const VIDEO_BLOCK_KEY = "media.block.video";

/** Catalog-ready manifest for the `video` block (key `media.block.video`). */
export function videoBlockManifest(): FeatureManifest {
  return {
    key: VIDEO_BLOCK_KEY,
    name: "Bloque de vídeo",
    description: `Reproduce un vídeo VOD (${videoBlock.type}) y lo completa por visionado (minWatchPct).`,
    scope: "course",
    status: "stable",
    gateable: true,
    since: "2026-06",
    docsSlug: "profesor",
    implications: {
      navHidden: ["«Vídeo» en el menú de bloques/módulos"],
      flowsBlocked: ["Subir vídeos nuevos"],
      dataPolicy: "preserved",
    },
  };
}
